import { useEffect, useState } from 'react';
import { api, formatDuration, timeAgo } from '../api.js';
import { UserChip } from '../components/UserChip.jsx';
import { Pagination } from '../components/Pagination.jsx';
import { useGuild } from './GuildLayout.jsx';

const COLORS = {
  warn: 'warn', timeout: 'warn', untimeout: 'success',
  kick: 'danger', ban: 'danger', unban: 'success',
  channel_mute: 'warn', channel_jail: 'danger',
  channel_unmute: 'success', channel_unjail: 'success',
  warning_deleted: '',
};

const PAGE = 50;

export default function ModLog() {
  const { guildId } = useGuild();
  const [data, setData] = useState(null);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    setData(null);
    api.modActions(guildId, `?limit=${PAGE}&offset=${offset}`).then(setData);
  }, [guildId, offset]);

  if (!data) return <div className="empty">Loading…</div>;

  return (
    <>
      <h1>Moderation log</h1>
      <p className="subtitle">{data.total.toLocaleString()} action{data.total === 1 ? '' : 's'} recorded.</p>
      {!data.actions.length ? (
        <div className="empty">No moderation actions yet.</div>
      ) : (
        <>
          <div className="card" style={{ padding: 0 }}>
            <table className="table">
              <thead>
                <tr>
                  <th>When</th>
                  <th>Action</th>
                  <th>Target</th>
                  <th>Moderator</th>
                  <th>Reason</th>
                  <th>Source</th>
                </tr>
              </thead>
              <tbody>
                {data.actions.map(a => (
                  <tr key={a.id}>
                    <td title={new Date(a.created_at * 1000).toLocaleString()} style={{ whiteSpace: 'nowrap' }}>{timeAgo(a.created_at)}</td>
                    <td>
                      <span className={`badge ${COLORS[a.action] || ''}`}>{a.action}</span>
                      {a.duration_ms && <span className="dim" style={{ marginLeft: 6 }}>{formatDuration(a.duration_ms)}</span>}
                    </td>
                    <td>{a.user_id === '0' ? <span className="dim">—</span> : <UserChip guildId={guildId} userId={a.user_id} size={20} />}</td>
                    <td><UserChip guildId={guildId} userId={a.moderator_id} size={20} /></td>
                    <td>{a.reason || <span className="dim">—</span>}</td>
                    <td><span className="badge">{a.source}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination total={data.total} limit={PAGE} offset={offset} onChange={setOffset} />
        </>
      )}
    </>
  );
}
